export default {"src":"/_next/static/media/img_survey_questionmark.6dd1c80b.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};